import { AppBar, Icon, Toolbar, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { PageWrapper } from 'components';
import { useHistory } from 'react-router-dom';
import QuizIcon from 'components/Icons/quiz.svg';
import { FinalReviewDialog } from 'pages/ListerVehicleUploadV2/InFormQuestionsDialog/FinalReview';
import { useDispatch } from 'react-redux';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { openCarInfoDialog, openFinalReviewDialog } from 'services/listerUploadVehicle/v2';
import OpenGeneralModalIcon from 'components/Icons/vehicleGoBack.svg';
import { VinInfoDialog } from 'components/ListVehicles/components/CreateVehicleDialog/VinInfoDialog';

const TypographyBreadcrumbs = styled(Typography)`
  font-size: 16px;
  flex-grow: 1;
`;

const StyledAppBar = styled(AppBar)`
  background: #fff;
  top: 72px;
`;

const MuiIcon = styled(Icon)`
  display: flex;
  margin-right: 8px;
  color: #000;
`;

const FinalReviewIcon = styled.div<{ withMargin?: boolean }>`
  margin-left: ${props => (props.withMargin ? 'auto' : '4px')};
  display: flex;
`;

export const Header = () => {
  const history = useHistory();

  const vehicleId = useGetVehicleId();

  const dispatch = useDispatch();
  const open = () => dispatch(openFinalReviewDialog(vehicleId));

  const goBack = () => {
    return history.goBack();
  };

  const openVinInfoDialog = () => dispatch(openCarInfoDialog({ vehicleId, type: 'mileage-update' }));

  return (
    <StyledAppBar position="fixed" color="default">
      <PageWrapper className="">
        <Toolbar disableGutters style={{ paddingRight: '4px' }}>
          <MuiIcon onClick={goBack}>arrow_back</MuiIcon>
          <TypographyBreadcrumbs variant="title">{'Vehicles'}</TypographyBreadcrumbs>
          <FinalReviewIcon withMargin onClick={openVinInfoDialog}>
            <OpenGeneralModalIcon />
          </FinalReviewIcon>
          <FinalReviewIcon onClick={open}>
            <QuizIcon />
          </FinalReviewIcon>
          <FinalReviewDialog />
          <VinInfoDialog />
        </Toolbar>
      </PageWrapper>
    </StyledAppBar>
  );
};
